import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import show_parasolid_svg from '../../../assets/img/SVG_icons/Top/reference_operation/show_reference_model.svg';
import { img } from '@phi/components';
import { SessionType } from '@phi/authentication/frontend';
import { hide_reference_parasolid_model, show_reference_parasolid_model } from '@frontend/scene';
import ShowParasolidTooltip from './ShowParasolidTooltip';

export const ShowSTLIcon = show_parasolid_svg;

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
        session_type: { required: true, type: null as any as PropType<Set<SessionType>> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Show/Hide Parasolid models';
        },

        disabled() {
            return !this.state.loaded;
        },
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else if (this.state.showing_reference_parasolid)
                hide_reference_parasolid_model();
            else
                show_reference_parasolid_model();
        },
    },

    render() {
        return h(BarButton, {
            id: 'show-parasolid-model-button',
            tippy: 'top',
            onClick: this.onClick,
            disabled: this.disabled,
            selected: this.state.tut_stage === 13,
            active: this.state.showing_reference_parasolid,
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(show_parasolid_svg, this.alt),
            tooltip: ShowParasolidTooltip,
        });
    },
});
